import React, { useEffect, useRef } from "react";
import { Provider } from "react-redux";
import { useLocation } from "react-router-dom";
import { store } from "../store/store";
import AppToasts from "../components/AppToasts/AppToasts";
import { SocketProvider } from "../socket/SocketContext";
import SocketReduxBridge from "../socket/SocketReduxBridge";
import { isAdminApiEnabled } from "../config/adminApiFeature";
import { isAdminAuthenticated } from "../utils/adminSession";
import { useAppDispatch } from "../store/hooks";
import { fetchDashboardOverview } from "../store/slices/dashboardSlice";
import { useAdminUnreadDocumentTitle } from "../hooks/useAdminUnreadDocumentTitle";

function AdminDocumentTitle() {
  useAdminUnreadDocumentTitle();
  return null;
}

/**
 * Load dashboard overview once per admin session so unread counts (and tab title) work on public routes too.
 */
function AdminDashboardBootstrap() {
  const dispatch = useAppDispatch();
  const { pathname } = useLocation();
  const apiOn = isAdminApiEnabled();
  const bootstrapped = useRef(false);

  useEffect(() => {
    if (!apiOn || !isAdminAuthenticated()) {
      bootstrapped.current = false;
      return;
    }
    if (!bootstrapped.current) {
      bootstrapped.current = true;
      dispatch(fetchDashboardOverview());
    }
  }, [apiOn, dispatch, pathname]);

  return null;
}

function AdminSocketGate({ children }) {
  useLocation();
  const apiOn = isAdminApiEnabled();
  const socketsActive = apiOn && isAdminAuthenticated();

  return (
    <SocketProvider active={socketsActive}>
      <SocketReduxBridge enabled={socketsActive} />
      <AdminDashboardBootstrap />
      <AdminDocumentTitle />
      {children}
    </SocketProvider>
  );
}

export default function AppProviders({ children }) {
  return (
    <Provider store={store}>
      <AdminSocketGate>
        <AppToasts />
        {children}
      </AdminSocketGate>
    </Provider>
  );
}
